export default "__VITE_ASSET__e089499c__"